// extracted by mini-css-extract-plugin
export default {"rating":"LL-z","numberOfStars":"ML-z","count":"NL-z","barGraphSpacing":"OL-z","barGraph":"PL-z"};